import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';
import device from '~/config/device';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 107px);
  background: var(--white);
  padding: 0 30px;
  overflow: auto;

  h1 {
    color: var(--blueDark);
  }

  button {
    background: var(--yellowDark);
    color: var(--blueDark);
    border-radius: 10px;
    padding: 5px 10px;
    margin-top: 15px;
    font-weight: bold;
    box-shadow: 2px 2px 2px rgba(12, 13, 14, 0.15);
    transition: background 0.2s;
  }

  button:hover {
    background: ${darken(0.06, '#f7c325')};
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 40px;
  color: var(--blueDark);
  margin: 10px;

  h3 {
    padding: 1px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 0.9rem;
  }

  h3.title {
    justify-content: space-between;
    align-items: center;
    margin: -1%;
    padding-right: 1%;
  }

  p {
    font-size: 1.7rem;

    @media (max-width: 426px) {
      font-size: larger;
    }
  }
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid var(--grayDark);
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;

export const SelectContainer = styled.div`
  width: 500px;
  padding-top: 50px;
  margin: 0 auto;
  text-align: center;

  @media ${device.mobileMinMobMax} {
    width: 80%;
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  color: var(--blueDark);
  font-size: 1.1rem;
  flex-direction: column;
  margin-bottom: 30px;

  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    border-bottom: 2px solid var(--yellowDark);
    padding: 15px 15px;
    margin: 0 30px;
  }

  section {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .bold {
    font-weight: bold;
  }

  .addressSection {
    margin-right: 8rem;
  }

  /* --- INÍCIO DA MÁGICA DE ALINHAMENTO --- */
  /* Forçamos a tabela a obedecer larguras fixas */
  table {
    width: 100%;
    table-layout: fixed !important;
    border-collapse: collapse;
  }

  /* Definimos as larguras: 15% para Data + 4 colunas de 21.25% (Total 100%) */
  /* O nth-child pega tanto o cabeçalho (th) quanto as células (td) */
  table th:nth-child(1), table td:nth-child(1) { width: 15%; }
  table th:nth-child(2), table td:nth-child(2) { width: 21.25%; }
  table th:nth-child(3), table td:nth-child(3) { width: 21.25%; }
  table th:nth-child(4), table td:nth-child(4) { width: 21.25%; }
  table th:nth-child(5), table td:nth-child(5) { width: 21.25%; }
`;

export const TotalRow = styled.div`
  display: flex !important; /* Use Flex, é mais fácil de controlar na impressão */
  width: 100%;
  background-color: #f9f9f9;
  border: 1px solid rgba(0,0,0,0.1);
  border-top: none;
  padding: 10px 0;
  margin-top: -1px !important;
  border-radius: 0 0 4px 4px;

  span {
    display: block;
    text-align: right;
    font-weight: bold;
    color: var(--blueDark);
    padding: 0 10px;
    /* Fonte original da tela (pode ser 1.1rem ou o que preferir) */
  }

  /* Definição das colunas (Soma total = 100%) */
  span:nth-child(1) { width: 15%; text-align: left; }
  span:nth-child(2) { width: 21.25%; }
  span:nth-child(3) { width: 21.25%; }
  span:nth-child(4) { width: 21.25%; }
  span:nth-child(5) { width: 21.25%; }
`;
